import { jsx as _jsx } from "react/jsx-runtime";
import { Container } from "../Container";
import { readableColor } from "polished";
import { socialNetworks } from "../icons";
import styled from "@emotion/styled";
import { useElementsContext } from "../elementsProvider";
import { toTestId } from "../utils";
export function RTCSocialNetworks({ iconsColor, subelements, }) {
    const { isMobile } = useElementsContext();
    return (_jsx(ContainerStyled, { children: _jsx(SocialNetworkContainer, Object.assign({ isDesktop: !isMobile }, { children: subelements.map((subelement) => (_jsx(SocialNetwork, Object.assign({ target: "_blank", href: subelement.url, title: subelement.iconName, backgroundColor: iconsColor, isDesktop: !isMobile, "data-testid": `${toTestId(subelement.iconName)}-social-network` }, { children: socialNetworks[subelement.iconName] }), subelement.identifier))) }), void 0) }, void 0));
}
const ContainerStyled = styled(Container)(() => ({
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
}));
const SocialNetworkContainer = styled.div(({ isDesktop }) => (Object.assign({ alignItems: "center", display: "flex", flexWrap: "wrap", justifyContent: "center", maxWidth: "23.6rem" }, (isDesktop
    ? {
        maxWidth: "100%",
    }
    : {}))));
const SocialNetwork = styled.a(({ backgroundColor, isDesktop }) => (Object.assign({ alignItems: "center", backgroundColor: backgroundColor, borderRadius: "50%", color: readableColor(backgroundColor), display: "flex", justifyContent: "center", margin: "1.6rem 1.2rem", padding: "0.8rem", textDecoration: "none", "& > svg": {
        color: "inherit",
        fontSize: "2rem",
    } }, (isDesktop
    ? {
        "&:hover": {
            opacity: "0.6",
        },
    }
    : {}))));
//# sourceMappingURL=RTCSocialNetworks.js.map